export default __webpack_public_path__ + "static/media/14.09f1a5c0.svg";